var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header-content"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../assets/images/logo.png"),"height":"32px","width":"125px"}})])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37010f2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderSimple.vue
// module id = null
// module chunks = 